import {
  Block,
  BLOCKS,
  Inline,
  Text,
  Document,
} from '@contentful/rich-text-types'

export function extractText(node: Block | Inline): string {
  return node.content
    .map((c: any) => (c.nodeType === 'text' ? (c as Text).value : ''))
    .join(' ')
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '')
}

export function extractHeadingsFromRichText(doc: Document): {
  id: string
  text: string
}[] {
  const headings: { id: string; text: string }[] = []

  const walk = (nodes: any[]) => {
    nodes.forEach((node) => {
      if (node.nodeType === BLOCKS.HEADING_2) {
        const text = extractText(node)
        const id = slugify(text)
        headings.push({ id, text })
      }
      if (node.content) walk(node.content)
    })
  }

  walk(doc.content)

  return headings
}
